import SalonManagerTemplate from "@admin/components/templates/SalonManager";
import Router from "@services/router";
import ClubsPage from "./components/pages/Clubs";
import SalonClubsPage from "./components/pages/SalonClubs";

export default [
    Router.page({ name: "admin:clubs", path: "/app/admin/groups", component: ClubsPage }),
    Router.group({ template: SalonManagerTemplate }, [
        Router.page({ name: "admin:salon:clubs", path: "/app/admin/salons/:id/groups", component: SalonClubsPage }),
    ])
]